import React, { Component } from "react";
import "./menu.css";
import ReactDOM from "react-dom";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";

// images
import Tel from "../../img/telegram.png";

import Uni from "../../img/uniswap.png";

import Del from "../../img/dextool.png";

import Gif from "../../img/logo gif .webp";

import logoimg from "../../img/logofinal.png";
import codeimage2 from "../../img/test.png";
import codeimage3 from "../../img/tabIcon.png";

const DesktopMenu = () => {
  return (
    <div className="pcc---headerMenu pt-4">
      <Container maxWidth="xl">
        <Grid container direction="row" justify="center" alignItems="center">
          <Grid container xs={1}>
            <a href="/">
              <img src={logoimg} style={{width: '100%', maxWidth: 85}}/>
             {/* <img src={logoimg}  style={{width: '72%'}}/> */}
            </a>
          </Grid>
          <Grid 
            container 
            direction="row" 
            justify="flex-end" 
            xs={11} style={{color:"white"}}>
            <ul>
              <li style={{paddingTop: '11px'}}>
                <a href="/#Feature">Features</a>
              </li>

              <li>
                {/* <a href="/presale">Presale</a> */}
              </li>
              <li style={{paddingTop: '11px'}}>
                <a href="/#Team">Team</a>
              </li>
              <li style={{paddingTop: '11px'}}>
                <a href="/white-paper">Litepaper</a>
              </li>
              <li style={{paddingTop: '11px'}}>
                <a href="/#FAQ">F.A.Q</a>
              </li>
              <li style={{paddingTop: '11px'}}>
                <a href="/#roadmap">Roadmap</a>
              </li>
               <li style={{paddingTop: '11px'}}>
                <a href="/lock-lp-token">Locker</a>
              </li>
            </ul>
              <a className="ml-2 mr-3 pcc-v3-3-menu_dapp_btn" href="https://exchange.pancakeswap.finance/#/swap?outputCurrency=0x41d7ca990138dddd70aef6a66cce6cf37b478428">
                <span>Buy Pcatv3 </span>
                <img src={codeimage3} className="img-fluid  ml-1" style={{width: "30px"}}  />
              </a>
              <a className="ml-1 pcc-v3-3-menu_dapp_btn" href="/dashboard">
                <span>Claim Rewards </span>
                <img src={codeimage2} className="img-fluid ml-1" style={{width: "30px"}}  />
              </a>
            
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default DesktopMenu;
